/* chr-header.js — WS-CHROME: compact "scrolled" state for the sticky header (html.chr-scrolled).
   Height is reserved by the sticky wrapper, so the shrink never moves page content (CLS 0). Vanilla, passive, rAF-throttled. */
(function () {
  'use strict';
  var root = document.documentElement, ticking = false, on = false;
  function update() {
    ticking = false;
    var y = window.pageYOffset || root.scrollTop || 0;
    var next = on ? y > 8 : y > 40; /* hysteresis so it never flickers at the threshold */
    if (next !== on) { on = next; root.classList.toggle('chr-scrolled', on); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
